module.exports = __webpack_public_path__ + "img/marker_two_blue2.23145016.png";